module.exports = __webpack_public_path__ + "img/1504318224.bdb34d55.jpg";